import Dialog from "@material-ui/core/Dialog";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import React from 'react';
import Button from 'react-bootstrap/Button'

// Única presentación del contenido compartido por bienvenida y documentación.
export function WelcomeContent({ msg, links: configuredLinks }) {
    const links = (Array.isArray(configuredLinks) ? configuredLinks : []).filter(
        link => link && typeof link.label === 'string' &&
            typeof link.url === 'string' && /^https?:\/\//i.test(link.url)
    );
    return (
        <>
            <DialogContentText style={{ whiteSpace: 'pre-line' }}>{msg}</DialogContentText>
            {links.length > 0 && (
                <ul style={{ paddingLeft: '1.25rem', overflowWrap: 'anywhere' }}>
                    {links.map((link, index) => (
                        <li key={`${link.url}-${index}`} style={{ marginBottom: '0.75rem' }}>
                            <a href={link.url} target="_blank" rel="noopener noreferrer">{link.label}</a>
                            {typeof link.description === 'string' && <span> — {link.description}</span>}
                        </li>
                    ))}
                </ul>
            )}
        </>
    );
}

class PopUpMsg extends React.Component {

	constructor(props) {
		super(props);

        this.state = {
                open: this.props.open

        }

    }
    handleToClose(){
        this.setState({open: false});
      };


    render() {


            return (

                <Dialog open={this.state.open} onClose={() => this.handleToClose()}>
                    <DialogTitle>{this.props.title}</DialogTitle>
                        <DialogContent>
                            <WelcomeContent msg={this.props.msg} links={this.props.links} />
                        </DialogContent>
                    <DialogActions>
                    <Button onClick={() => this.handleToClose()}
                            color="primary" autoFocus variant="outline-success">
                        Cerrar
                    </Button>
                    </DialogActions>
              </Dialog>

                )
        }
}
export default PopUpMsg;
